import {Controller} from '@hotwired/stimulus';

/**
 * Recopie la saisie d'un champ dans ses champs miroirs, typiquement les champs masqués qui portent
 * la même valeur pour chaque langue.
 *
 *   <form {{ stimulus_controller('field-mirror') }}>
 *     {{ form_row_v(form.versions, 'space_id', {attr: stimulus_target('field-mirror', 'mirror').toArray()}) }}
 *     <input type="text" {{ stimulus_action('field-mirror', 'copy', 'input') }}>
 *   </form>
 *
 * Plusieurs champs partagés dans un même formulaire : la source nomme son groupe en paramètre d'action,
 * chaque miroir le porte en `data-field-mirror-group`.
 *
 *     {{ form_row_v(form.versions, 'display', {attr: {'data-field-mirror-group': 'display'}|merge(stimulus_target('field-mirror', 'mirror').toArray())}) }}
 *     <select {{ stimulus_action('field-mirror', 'copy', 'change', {group: 'display'}) }}>
 */
export default class extends Controller {
  static targets = ['mirror'];

  copy(event) {
    const {value} = event.currentTarget;
    const {group} = event.params;

    for (const mirror of this.mirrorTargets) {
      if (group === undefined || mirror.dataset.fieldMirrorGroup === group) {
        mirror.value = value;
      }
    }
  }
}
